module.exports = __webpack_public_path__ + "img/talia-hibbert.64e074c0.png";